import React from 'react';
import Masonry from 'react-masonry-css';
import { motion } from 'framer-motion';
import Tilt from 'react-parallax-tilt';
import './IllustrationWork.css';

const images = [
  'illustration/penguin.png',
  'illustration/french_fries.png',
  'illustration/car.png',
  'illustration/car_grey.png',
  'illustration/car_glass.png'
];

const breakpointColumnsObj = {
  default: 5,
  1100: 3,
  700: 2
};

const IllustrationWork = () => {
  return (
    <>
      {/* 🎨 Hero Section */}
      <motion.div
        className="illustration-hero-section"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>Cute & Minimal Vector Illustrations 🎨</h1>
        <p>Delightfully small. Smoothly vector. Lovingly crafted.</p>
      </motion.div>

      {/* 🧱 Masonry Gallery */}
      <motion.div
        className="illustration-gallery"
        initial="hidden"
        animate="visible"
        variants={{
          visible: {
            transition: { staggerChildren: 0.1 }
          }
        }}
      >
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="illustration-masonry-grid"
          columnClassName="illustration-masonry-grid-column"
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              variants={{
                hidden: { opacity: 0, y: 30 },
                visible: { opacity: 1, y: 0 }
              }}
            >
              <Tilt
                glareEnable={true}
                glareMaxOpacity={0.3}
                scale={1.05}
                tiltMaxAngleX={8}
                tiltMaxAngleY={8}
              >
                <div className="illustration-card">
                  <img
                    src={`images/${image}`}
                    alt={`Illustration ${index + 1}`}
                  />
                  <a
                    href={`images/${image}`}
                    download={`illustration${index + 1}.png`}
                    className="illustration-download-button"
                  >
                    📥 Download
                  </a>
                </div>
              </Tilt>
            </motion.div>
          ))}
        </Masonry>
      </motion.div>

      {/* 💫 Stay Tuned Section */}
      <section className="illustration-stay-tuned">
        <p>Stay tuned for more Illustrations 😊❤️</p>
      </section>
    </>
  );
};

export default IllustrationWork;
